import { makeStyles, withStyles } from '@material-ui/core/styles';

import MessageIcon from '@material-ui/icons/Message';
import PropTypes from 'prop-types';
import React from 'react';
import Typography from '@material-ui/core/Typography';

const StyledMessageIcon = withStyles(theme => ({
  root: {
    color: theme.palette.primary.main,
  },
}))(MessageIcon);

const useStyles = makeStyles(theme => ({
  root: {
    padding: '0.25rem',
    display: 'flex',
    flexWrap: 'nowrap',
    alignContent: 'left',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  icon: {
    marginRight: 10,
  },
  text: {
    padding: 0,
    paddingLeft: '0px',
    fontSize: '0.9rem',
    color: theme.palette.primary.main,
    whiteSpace: 'nowrap',
    '&:hover': {
      color: ({shouldHover}) => shouldHover && theme.palette.secondary.main,
      cursor: ({shouldHover}) => shouldHover && 'pointer',
      textDecoration: ({shouldHover}) => shouldHover && 'underline',
    },
  },
}));

const ReviewCount = ({count, onClick, ...props}) => {
  const classes = useStyles({shouldHover: !!onClick});
  return (
    <div className={classes.root} {...props}>
      <StyledMessageIcon className={classes.icon} />
      <Typography
        variant="caption"
        color="primary"
        className={classes.text}
        onClick={() => !!onClick && onClick()}
      >
        {count} reviews
      </Typography>
    </div>
  );
};

ReviewCount.propTypes = {
  count: PropTypes.number.isRequired,
  onClick: PropTypes.func,
};

export default ReviewCount;
